import { apiClient } from './client';
import type {
  CasinoApiConfig,
  LambdaApiConfig,
  OpenAIApiConfig,
} from '@/types/api-config.types';

export const apiConfigsApi = {
  getCasino: async (): Promise<CasinoApiConfig> => {
    const { data } = await apiClient.get<CasinoApiConfig>('/admin/api-config', {
      params: { provider: 'casino' },
    });
    return data;
  },
  updateCasino: async (config: CasinoApiConfig): Promise<CasinoApiConfig> => {
    const { data } = await apiClient.put<CasinoApiConfig>('/admin/api-config', config, {
      params: { provider: 'casino' },
    });
    return data;
  },

  getOpenai: async (): Promise<OpenAIApiConfig> => {
    const { data } = await apiClient.get<OpenAIApiConfig>('/admin/api-config', {
      params: { provider: 'openai' },
    });
    return data;
  },
  updateOpenai: async (config: OpenAIApiConfig): Promise<OpenAIApiConfig> => {
    const { data } = await apiClient.put<OpenAIApiConfig>('/admin/api-config', config, {
      params: { provider: 'openai' },
    });
    return data;
  },

  getLambda: async (): Promise<LambdaApiConfig> => {
    const { data } = await apiClient.get<LambdaApiConfig>('/admin/api-config', {
      params: { provider: 'lambda' },
    });
    return data;
  },
  updateLambda: async (config: LambdaApiConfig): Promise<LambdaApiConfig> => {
    const { data } = await apiClient.put<LambdaApiConfig>('/admin/api-config', config, {
      params: { provider: 'lambda' },
    });
    return data;
  },
};
